import { render, staticRenderFns } from "./RequestEntity.vue?vue&type=template&id=65e4aa88&scoped=true"
import script from "./RequestEntity.vue?vue&type=script&lang=js"
export * from "./RequestEntity.vue?vue&type=script&lang=js"
import style0 from "./RequestEntity.vue?vue&type=style&index=0&id=65e4aa88&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4aa88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e4aa88')) {
      api.createRecord('65e4aa88', component.options)
    } else {
      api.reload('65e4aa88', component.options)
    }
    module.hot.accept("./RequestEntity.vue?vue&type=template&id=65e4aa88&scoped=true", function () {
      api.rerender('65e4aa88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RequestEntity.vue"
export default component.exports